import {
  Card,
  Toolbar,
  OutlinedInput,
  InputAdornment,
  // Button,
  TablePagination,
  Table,
  TableBody,
  TableContainer,
  TableRow,
  TableHead,
  TableCell,
  TableSortLabel,
  Box,
  Paper,
  Typography,
  Skeleton,
  IconButton,
  Stack,
} from "@mui/material";
import Iconify from "../iconify";
import Scrollbar from "src/components/scrollbar";
import { visuallyHidden } from "./utils/utils";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const TableDataLoading = ({ headCount,showMenuOnload }) => {
  return [1, 2, 3, 4, 5].map((count) => (
    <TableRow key={count} hover tabIndex={-1}>
      <TableCell padding="normal" width={"10px"}><Skeleton variant="text" sx={{width:"25px"}}/></TableCell>
      {[...Array(!showMenuOnload ? (headCount - 1 ) : (headCount - 2) ).keys()].map((colCount) => (
        <TableCell padding="normal" 
                   align="left" 
                   key={colCount}>
          <Typography variant="h6">
            <Skeleton variant="text" />
          </Typography>
        </TableCell>
      ))}
      {showMenuOnload && <TableCell align="right" width={"10px"}>
        <IconButton>
          <Iconify icon="eva:more-vertical-fill" />
        </IconButton>
      </TableCell>}
    </TableRow>
  ));

};

const TableNoData = ({ headCount, query }) => {
  return (
    <TableRow>
      <TableCell padding="normal" width={"10px"}></TableCell>
      <TableCell align="center" colSpan={headCount - 1} sx={{ py: 3 }}>
        <Paper
          sx={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            width: "100%",
            height: "300px",
          }}
        >
          <Box>
            <Box sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}>
              <Box
                sx={{
                  height: 200,
                  width: 400,
                  backgroundImage:
                    "url(/assets/illustrations/table-no-results.png)",
                  backgroundPosition: "center",
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",

                }}
              ></Box>

            </Box>
            {query && (
              <Typography variant="body1">
                No records found for &nbsp;
                <strong>&quot;{query}&quot;</strong> !!.
              </Typography>
            )}
            {!query && (
              <Typography variant="body1">No records found !!.</Typography>
            )}
          </Box>
        </Paper>
      </TableCell>
    </TableRow>
  );
};
export function CustomTable({
  instanceSearch,
  rowCount,
  headLabel,
  tableBody,
  loading,
  hasRecords,
  query,
  otherTools,
  showTools = true,
  showPagination = true,
  searchType = "text",
  showCard = true,
  showMenuOnload = true,
  toolsContainerPadding=5,
  filterChanged
}) {
  const { search } = useSelector((state) => state.search);
  const [state, setState] = useState({
    loading: false,
    hasRecords: true,
  });
  const order = instanceSearch.values.order_type;
  const orderBy = instanceSearch.values.order_by;
  const headCount = !headLabel ? 0 : headLabel.length;
  const handleState = (key, value) =>
    setState((prev) => ({ ...prev, [key]: value }));
  const onSort = (property) => (event) => {
    const isAsc =
      instanceSearch.values.order_by === property &&
      instanceSearch.values.order_type === "asc";
    if (property !== "") {
      instanceSearch.setFieldValue("order_type", isAsc ? "desc" : "asc");
      instanceSearch.setFieldValue("order_by", property);
      instanceSearch.handleSubmit();
    }
  };
  const handleChangePage = (event, newPage) => {
    instanceSearch.setFieldValue("page", newPage);
    instanceSearch.handleSubmit();
  };
  const handleChangeRowsPerPage = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(
      (instanceSearch.values.page * instanceSearch.values.limit) / newLimit
    );
    
    // Set the new limit and adjust the page
    instanceSearch.setFieldValue("limit", newLimit);
    instanceSearch.setFieldValue("page", newPage);
    
    // Submit the search with the updated limit and page values
    instanceSearch.handleSubmit();
  };

  
  
  useEffect(() => {
    handleState("loading", loading);
    handleState("hasRecords", hasRecords);
  }, [loading, hasRecords]);

  useEffect(()=>{
    if(filterChanged === true){
      instanceSearch.setFieldValue("page", 0);
    }
  },[filterChanged])

  const renderData = () => {
    return (<>
      {showTools && (
        <form onSubmit={instanceSearch.handleSubmit} autoComplete="off">
          <Toolbar
            sx={{
              // height: 96,
              display: "flex",
              justifyContent: "space-between",
              // p: (theme) => theme.spacing(0, 1, 0, 3),
              overflowY: "auto",
              overflowX: "none",
              padding: toolsContainerPadding,
              // backgroundColor:"turquoise"
            }}
          >
            <>
              <Stack direction="row" spacing={1}>
                <OutlinedInput
                  name="search"
                  type={searchType}
                  value={instanceSearch.values.search}
                  onChange={(e) => {
                    const search = e.target.value;
                    instanceSearch.setFieldValue("search", search);
                    instanceSearch.setFieldValue("page", 0);
                    instanceSearch.handleSubmit();
                  }}
                  onKeyDown={(e) => {
                    if (searchType === "number") {
                      if (["-", "+", "."].includes(e.key)) {
                        e.preventDefault();
                      }
                    }
                  }}

                  placeholder="Search here..."
                  size="small"
                  startAdornment={
                    <InputAdornment position="start">
                      <Iconify
                        icon="eva:search-fill"
                        sx={{ color: "text.disabled", width: 20, height: 20 }}
                      />
                    </InputAdornment>
                  }
                />
                {otherTools ? otherTools : null}
              </Stack>
              
            </>
          </Toolbar>
        </form>
      )}
      <Scrollbar>
        <TableContainer sx={{ overflow: "unset" }}>
          <Table sx={{ minWidth: 800 }}>
            <TableHead>
              <TableRow>
                {headLabel.map((headCell) => (
                  <TableCell
                    key={headCell.id}
                    align={headCell.align}
                    sortDirection={orderBy === headCell.id ? order : false}
                    sx={{
                      width: headCell.width,
                      minWidth: headCell.minWidth,
                      whiteSpace: "nowrap",
                    }}
                  >
                   {headCell.sortStatus === "hide"?
                    (
                      headCell.label
                    )
                   :<TableSortLabel
                      hideSortIcon={true}
                      active={orderBy === headCell.id}
                      direction={orderBy === headCell.id ? order : "asc"}
                      onClick={onSort(headCell.id)}
                    >
                      {headCell.label}
                      {orderBy === headCell.id ? (
                        <Box sx={{ ...visuallyHidden }}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </Box>
                      ) : null}
                    </TableSortLabel>}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableBody}
              {!loading && !state.loading && !state.hasRecords && (
                <TableNoData headCount={headCount} query={query} />
              )}
              {/* loading && */}
              {
                loading && 
                <TableDataLoading headCount={headCount} showMenuOnload={showMenuOnload} />
              }
            </TableBody>
          </Table>
        </TableContainer>
      </Scrollbar>
      {(showPagination && rowCount > 5) && (
        <TablePagination
          page={(search?.page ? search.page : instanceSearch.values.page) || 0}
          component="div"
          count={rowCount}
          rowsPerPage={
            search?.limit ? search?.limit : instanceSearch.values.limit
          }
          onPageChange={handleChangePage}
          rowsPerPageOptions={[5, 10, 25]}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </>);
  }


  if (showCard) {
    return (
      <Card sx={{ pb: !showPagination ? 5 : 0, pt: !showTools ? 5 : 0 }}>
        {renderData()}
      </Card>
    )
  }
  else {
    return renderData();
  }
}
